<template>
<div class="test-plot">
  <bar-graph
    :height="200"
    :data="bars"
    :options="options"
    />
</div>
</template>
<script>
import BarGraph from './BarGraph.vue'
import groupCount from 'script/groupCount.js'

export default {
  components: { BarGraph },
  props: ['data'],
  watch: {
    data: {
      deep: true,
      handler: 'update'
    }
  },
  data () {
    return {
      bars: {},
      options: {
        color: ['#1181C2']
      }
    }
  },
  mounted () {
    this.update()
  },
  methods: {
    update () {
      if (!this.data) {
        console.log('no data', this.data)
        return
      }

      const timestamps = this.data.map(({ date }) => date)

      const weekMap = groupCount.perWeek(timestamps)
      const labels = []
      const quantities = []

      Object.entries(weekMap).forEach(([a, b]) => {
        labels.push(a.substring(4, 6))
        quantities.push(b)
      })

      this.bars = {
        labels: labels,
        datasets: [{
          label: 'Subscribers',
          backgroundColor: '#f87979',
          data: quantities
        }]
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .test-plot {
    position: relative;
    width: 100%;
    height: auto;
  }
</style>
